<template>
  <RygenMultiSelect
    :id="id"
    v-model="internalValue"
    :disabled="disabled"
    :loading="loading"
    :options="options"
    :placeholder="placeholder"
    display="chip"
    class="mode-multi-select"
    option-label="label"
    option-value="value"
    filter
  />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs, useAttrs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue, useUid } from '@rygen/rygen-ui/composables';
import { mapEnumToTranslatedDropdownValues } from '@rygen/rygen-ui/i18n';
import { Mode } from '@rygen/rygen-ui/model';

import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';

const props = defineProps({
  id: {
    type: String,
    default: () => useUid('mode-select').uid,
  },
  modelValue: {
    type: Array as PropType<Mode[]>,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  loading: {
    type: Boolean,
    default: () => false,
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: Mode[]): void;
}>();

const attrs = useAttrs();
const { t } = useI18n();

const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<Mode[]>) => opts,
});

const placeholder = computed(() => {
  return (attrs.placeholder as string) ?? t('shipments.modes', 2);
});

const options = mapEnumToTranslatedDropdownValues(Mode, 'Mode');
</script>
